/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */

import $ from 'jquery';

document.addEventListener('DOMContentLoaded', function () {
  const $sectionHours = $('.section-hours');

  function checkHours(sectionHours) {
    if (sectionHours.length != 0) {
      sectionHours.each(function () {
        const $salesPane = $(this).find('.hours-content .tab-content .tab-pane:first-child');

        if ($salesPane.hasClass('show')) {
          $(this).addClass('sales-active');
        } else {
          $(this).removeClass('sales-active');
        }
      });
    }
  }

  checkHours($sectionHours);

  $('.section-hours .nav-link').on('click', function() {
    const $sectionHours = $(this).parents('.section-hours');
    checkHours($sectionHours);

  });


});
